import assetPath from '/app/brewery-packages/xds/background-images/assets/Background_01_1x1_a.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')